import React from "react";
import ActionButton from "./ActionButton";
import ButtonStyle from "./ButtonStyle";
import PrimaryButton from "./PrimaryButton";
import OutlineButton from "./OutlineButton";
import IconButton from "./IconButton";
import './style.css';

const HexButton = ({ type, ...props }) => {
  const elementButton = {
    primary: () => <PrimaryButton {...props} type={type} />,
    outline: () => <OutlineButton {...props} type={type} />,
    filter: () => <ButtonStyle {...props} type={type} />,
    clear: () => <ButtonStyle {...props} type={type} />,
    icon: () => <IconButton {...props} type={type} />,
    action: () => <ActionButton {...props} />,
  };

  return elementButton[type]
    ? elementButton[type]()
    : console.log("button type does not exist");
};

export default HexButton;
